import Swal from 'sweetalert2';
import React from 'react';

import http from 'services/http';
import axios from 'axios';
import {moedaInput, parseMoeda} from '../../../../utils/moedaInput';

export default class Criar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nome: '',
            sorteios: '5',
            milharMoto: '0',
            modalidade: 'tradicional',
            maximo_premio: '',
            cotas_premio: '',
            listaCotacoes: [],
            loteria_central: '',
            listaLoterias: [],
            hora: '',
            salvo: false,
            error: false,
            carregaPost: false,
            semana: [
                {
                    dia: 'Segunda',
                    ativo: false
                },
                {
                    dia: 'Terça',
                    ativo: false
                },
                {
                    dia: 'Quarta',
                    ativo: false
                },
                {
                    dia: 'Quinta',
                    ativo: false
                },
                {
                    dia: 'Sexta',
                    ativo: false
                },
                {
                    dia: 'Sábado',
                    ativo: false
                },
                {
                    dia: 'Domingo',
                    ativo: false
                },
            ]
        };
    }

    componentDidMount() {
        this.requestLoteriasCentral();
        this.requestCotacoes();
    }

    changerCheckBox = (dia, index) => {
        const {semana} = this.state;
        semana[index].ativo = !dia.ativo;

        this.setState({semana});
    };

    renderCheckBox = () => {
        return this.state.semana.map((item, index) => {
            return (
                <label key={index} className="control-label" style={{marginRight: '15px'}}>
                    <input
                        type="checkbox"
                        checked={item.ativo}
                        onChange={() => {
                            this.changerCheckBox(item, index);
                        }}
                    />
                    &nbsp;
                    {item.dia}
                </label>
            );
        });
    };

    formatarMoeda = (valor) => {
        if (!valor) return '';
        
        const numero = valor.toString().replace(/\D/g, '');
        
        const decimal = (parseFloat(numero) / 100).toFixed(2);
        
        return decimal;
    };

    exibirValorFormatado = (valor) => {
        if (!valor) return '';
        
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    salvarExtracao = async () => {
        try {
            this.setState({carregaPost: true});
            const {
                nome, 
                hora, 
                sorteios, 
                milharMoto, 
                maximo_premio,
                cotas_premio,
                semana, 
                loteria_central, 
                modalidade
            } = this.state;

            await http.post('/loterias', {
                nome: nome,
                hora: hora + ':00',
                segunda: semana[0].ativo,
                terca: semana[1].ativo,
                quarta: semana[2].ativo,
                quinta: semana[3].ativo,
                sexta: semana[4].ativo,
                sabado: semana[5].ativo,
                domingo: semana[6].ativo,
                quantidade_sorteios: sorteios,
                milhar_moto: milharMoto,
                maximo_premio: maximo_premio ? parseMoeda(maximo_premio) : null,
                cotas_premio: cotas_premio || null,
                central_id: loteria_central,
                modalidade: 'tradicional'
            });

            Swal.fire({
                type: 'success',
                title: 'Criado com sucesso'
            });

            this.props.history.push('/extracao');
        } catch (e) {
            Swal.fire({
                type: 'error',
                title: 'Não foi possível criar'
            });
            this.setState({carregaPost: false});
        }
    };

    requestLoteriasCentral = async () => {
        try {
            const response = await axios.get('https://centralsete.com/api/loterias');

            const loterias_central = response.data.loterias;

            this.setState({listaLoterias: loterias_central});
        } catch (e) {
        }
    }

    requestCotacoes = async () => {
        try {
            const response = await http.get('bancas/titulo-cotacoes');
            this.setState({listaCotacoes: response.data.data || []});
        } catch (e) {
        }
    }

    render() {
        return (
            <div className="bordered">
                <div>
                    <div className="titulo-principal">Criar Loteria</div>
                    <div className="btn-group caixa-inputs p-b">
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Nome da loteria:</label>
                            <input
                                required
                                onChange={(c) => this.setState({nome: c.target.value})}
                                type="text"
                                className="form-control input-dados-criar"
                            />
                        </div>

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Encerra:</label>
                            <input
                                required
                                onChange={(c) => this.setState({hora: c.target.value})}
                                type="time"
                                className="form-control input-dados-criar"
                            />
                        </div>

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Sorteios:</label>
                            <select
                                className="form-control input-dados-criar"
                                onChange={(e) => this.setState({sorteios: e.target.value})}
                                value={this.state.sorteios}
                            >
                                <option value="5">1a5</option>
                                <option value="7">1a7</option>
                                <option value="10">1a10</option>
                            </select>
                        </div>

                        {/* <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Modalidade:</label>
                            <select
                                className="form-control input-dados-criar"
                                value={this.state.modalidade}
                                onChange={(e) => this.setState({modalidade: e.target.value})}
                            >
                                <option value="tradicional">Tradicional</option>
                            </select>
                        </div> */}

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Máx. Prêmios:</label>
                            <input
                                onChange={(e) => this.setState({maximo_premio: moedaInput(e.target.value)})}
                                type="text"
                                inputMode="numeric"
                                className="form-control input-dados-criar"
                                value={this.state.maximo_premio}
                                placeholder="0,00"
                            />
                        </div>

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Cotação p/ cálculo:</label>
                            <select
                                className="form-control input-dados-criar"
                                onChange={(e) => this.setState({cotas_premio: e.target.value})}
                                value={this.state.cotas_premio}
                            >
                                <option value="">Selecione a cotação</option>
                                {this.state.listaCotacoes.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.nome}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Central:</label>
                            <select
                                className="form-control input-dados-criar"
                                onChange={(e) => this.setState({loteria_central: e.target.value})}
                            >
                                <option value="">Selecione uma central</option>
                                {this.state.listaLoterias.map((u) => (
                                    <option key={u.loteria_id} value={u.loteria_id}>
                                        {u.nome}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">Dias da semana:</label>
                            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                {this.renderCheckBox()}
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            padding: "0 10px",
                            justifyContent: "left",
                        }}
                        className="d-flex m-b m-t"
                    >
                        <button
                            style={{
                                display: "block",
                                width: "270px",
                                marginLeft: "150px",
                            }}
                            className="btn btn-success"
                            onClick={() => this.salvarExtracao()}
                            disabled={this.state.carregaPost}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}